export default __webpack_public_path__ + "static/media/Raider's Vambraces of the Howling Moon.ab6a5a9e.jpg";